import Phaser from 'phaser';
import { GAME_CONFIG } from './constants';

/**
 * Main Phaser game configuration
 */
export const gameConfig: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO, // Use WebGL if available, fall back to Canvas
  parent: 'game-container',
  width: GAME_CONFIG.WIDTH,
  height: GAME_CONFIG.HEIGHT,
  backgroundColor: '#000000',
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
  physics: {
    default: 'arcade',
    arcade: {
      gravity: { x: 0, y: 0 }, // We'll handle gravity manually for balls
      debug: false, // Set to true for collision box visualization
    },
  },
  input: {
    gamepad: true, // USB / Bluetooth controllers (axis movement, button 1 = shoot)
  },
  fps: {
    target: GAME_CONFIG.FPS,
    forceSetTimeOut: false,
  },
  render: {
    antialias: true,
    pixelArt: false,
    roundPixels: false,
  },
  // Scenes will be added in main.ts
  scene: [],
};
